module.exports = __webpack_public_path__ + "img/Bouton_Air.beee0a85.png";